<template>
  <div class="content">
    <div class="container-fluid p-0 col-6">
      <card>
        <h4 slot="header" class="card-title">Detail uživatelského oprávnění</h4>
        <form>
          <div class="row">
            <div class="col-12">
              <base-input type="text" label="Název" v-model="userPermissionObject.Name" />
            </div>
          </div>

          <hr>
          <div class="text-center">
            <button type="submit" class="btn btn-success btn-fill float-right" @click.prevent="saveData">
              Uložit
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/Card.vue';
  import dataService from '@/services/dataService.js';
  import vueFormHelper from '@/js/VueFormHelper.js';

  export default {
    components: {
      Card
    },
    methods: {
      async saveData() {
        vueFormHelper.saveData(this, $TablesEnum.userPermission, this.userPermissionObject, '/users');
      }
    },
    mounted: async function () {
      this.newForm = this.$route.query.newForm;
      if ((this.newForm != undefined) && (!this.newForm))
        this.userPermissionObject = this.$route.query.objectData;
    },
    data () {
      return {
        newForm: true,
        userPermissionObject: {
          Id: -1,
          Name: null
        }
      }
    }
  }
</script>